import ReactDOM from 'react-dom'
import { Modal, Card, Row, Col, Popover, Tooltip, Typography } from 'antd'
import { QuestionCircleOutlined, DownloadOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { getServiceDescription } from 'Services/ServiceDescriptions'
import getTemplate from './templates'
import { Command } from 'react-feather'
import './index.scss'
{ Paragraph, Text } = Typography

downloadFileIcon = (url) ->
  <Tooltip
    title="Download example file"
    placement="left"
  >
    <a
      href={url}
      className="helper-icon">
      <DownloadOutlined />
    </a>
  </Tooltip>

export default showActionsPage = (props = {}) ->
  {
    title,
    component,
    description,
    serviceName,
    serviceCall,
    key,
    profile
  } = props

  ActionsPage = getTemplate(component, props.componentConf)

  actionDescription = description or getServiceDescription(serviceName, serviceCall, profile, component)

  div = document.createElement('div')
  document.body.append(div)

  destroy = ->
    unmountResult = ReactDOM.unmountComponentAtNode(div)
    if unmountResult and div.parentNode
      div.parentNode.removeChild(div)

  helpText = (
    <div style={{ width: 500, lineHeight: '1.6rem', whiteSpace: 'pre-wrap' }}>
      <Paragraph data-testid="action-primary-text">
        { actionDescription?.primary }
      </Paragraph>
      <Text type="secondary" data-testid="action-secondary-text">
        { actionDescription?.secondary }
      </Text>
    </div>
  )

  renderedTitle = (
    <div
      className="title-container"
      data-testid={_.kebabCase(title)}
    >
      <div className='title'>
          <Command className="actionIcon"/>
          <span
            className='title-text'
            data-testid="action-help-title"
          >
            { title }
          </span>
      </div>

      <Row gutter={16} className="helpers" align="middle">
        {
          if props.profile is 'excel-path'
            <Col>
              { downloadFileIcon('https://downloads.sysunite.com/files/excel-path_fish_example.xlsx') }
            </Col>
        }
        {
          if actionDescription?
            <Col>
              <Popover
                content={helpText}
                title={title}
                trigger="click"
                placement="left"
              >
                <a>
                  <QuestionCircleOutlined
                    data-testid="action-pages-helper"
                  />
                </a>
              </Popover>
            </Col>
        }
      </Row>
    </div>
  )

  ActionPageModal = ({ destroy }) ->
    [visible, setVisible] = useState(true)
    props.destroy = destroy

    <Modal
      maskClosable={false}
      centered={true}
      width={Math.max(700, window.innerWidth * 0.67)}
      className="actions-page-container"
      visible={visible}
      footer={null}
      onCancel={-> setVisible(false)}
      afterClose={destroy}
      title={renderedTitle}
    >
      <div className="content">
        <ActionsPage {props...} />
      </div>
    </Modal>

  ReactDOM.render(
    <ActionPageModal destroy={destroy} />
  , div)
